import { createUseInfiniteQuery } from "eddev/hooks";
import {
  UseInfiniteArticlesSearchQuery,
  UseInfiniteArticlesSearchQueryVariables,
  UseInfiniteContentItemsQuery,
  UseInfiniteContentItemsQueryVariables,
  UseInfinitePodcastsSearchQuery,
  UseInfinitePodcastsSearchQueryVariables,
  UseInfiniteSiteSearchQuery,
  UseInfiniteSiteSearchQueryVariables,
  UseInfiniteWhitepapersSearchQuery,
  UseInfiniteWhitepapersSearchQueryVariables,
} from "../types.graphql";

/**
 * DO NOT EDIT
 * This file is automatically generated by eddev
 * Any changes will be overwritten
 */

export const useInfiniteArticlesSearch = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteArticlesSearchQuery["articles"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteArticlesSearchQueryVariables
>({
  name: "UseInfiniteArticlesSearch",
  defaultLimit: 8,
  paths: {
    "nodesPath": ["articles", "nodes"],
    "pageInfoPath": ["articles", "pageInfo"],
    "endCursorPath": ["articles", "pageInfo", "endCursor"],
    "hasNextPagePath": ["articles", "pageInfo", "hasNextPage"],
  },
});

export const useInfiniteContentItems = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteContentItemsQuery["contentNodes"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteContentItemsQueryVariables
>({
  name: "UseInfiniteContentItems",
  defaultLimit: 10,
  paths: {
    "nodesPath": ["contentNodes", "nodes"],
    "pageInfoPath": ["contentNodes", "pageInfo"],
    "endCursorPath": ["contentNodes", "pageInfo", "endCursor"],
    "hasNextPagePath": ["contentNodes", "pageInfo", "hasNextPage"],
  },
});

export const useInfinitePodcastsSearch = createUseInfiniteQuery<
  Exclude<Exclude<UseInfinitePodcastsSearchQuery["podcasts"], undefined | null>["nodes"], undefined | null>,
  UseInfinitePodcastsSearchQueryVariables
>({
  name: "UseInfinitePodcastsSearch",
  defaultLimit: 8,
  paths: {
    "nodesPath": ["podcasts", "nodes"],
    "pageInfoPath": ["podcasts", "pageInfo"],
    "endCursorPath": ["podcasts", "pageInfo", "endCursor"],
    "hasNextPagePath": ["podcasts", "pageInfo", "hasNextPage"],
  },
});

export const useInfiniteSiteSearch = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteSiteSearchQuery["contentNodes"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteSiteSearchQueryVariables
>({
  name: "UseInfiniteSiteSearch",
  defaultLimit: 100,
  paths: {
    "nodesPath": ["contentNodes", "nodes"],
    "pageInfoPath": ["contentNodes", "pageInfo"],
    "endCursorPath": ["contentNodes", "pageInfo", "endCursor"],
    "hasNextPagePath": ["contentNodes", "pageInfo", "hasNextPage"],
  },
});

export const useInfiniteWhitepapersSearch = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteWhitepapersSearchQuery["whitePapers"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteWhitepapersSearchQueryVariables
>({
  name: "UseInfiniteWhitepapersSearch",
  defaultLimit: 8,
  paths: {
    "nodesPath": ["whitePapers", "nodes"],
    "pageInfoPath": ["whitePapers", "pageInfo"],
    "endCursorPath": ["whitePapers", "pageInfo", "endCursor"],
    "hasNextPagePath": ["whitePapers", "pageInfo", "hasNextPage"],
  },
});
